Dispatcher = require '../dispatcher/Dispatcher'
ActionTypes = require '../constants/ActionTypes'

module.exports =
  setComponent: (component) ->
    Dispatcher.dispatch type: ActionTypes.CONVERSATION_MOCK_SHOW, payload: component

  removeComponent: ->
    Dispatcher.dispatch type: ActionTypes.CONVERSATION_MOCK_HIDE
